import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, useMediaQuery } from '@mui/material';
import { Button, CircularProgress, NavHeader } from '../../../../../../components';
import { Page } from '../../../../../../components/page';
import { useSupportedDevices } from '../../../../../../hooks/supported-devices/use-supported-devices';
import { DashboardResourceItem, ObjectFitType } from '../../components/dashboard-resource-item/dashboard-resource-item';
import { meterDevicesModelGuids, storeMainLink } from '../../utils/meter-devices';

const MeterDevices: React.FC = () => {
  const { t } = useTranslation('dashboard');
  const { t: tc } = useTranslation('common');
  const { data, isLoading } = useSupportedDevices();
  const isSmall = useMediaQuery('(max-width:430px)');
  const gridSize = { xs: isSmall ? 12 : 6, sm: 6, md: 4 };

  const handleRedirect = (url: string) => window.open(url, '_blank');

  return (
    <Page
      isStickyHeader
      containerClassName="page__container--flex-height p-t-0"
      header={<NavHeader title={t('statistics.meterDevices')} hasLineBelow />}
    >
      <Box paddingTop={2} paddingBottom={4}>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <Grid container spacing={2}>
            {(data || [])
              .filter((x) => meterDevicesModelGuids.includes(x.ModelGuid))
              .map((x, index) => (
                <Grid key={index} size={gridSize}>
                  <DashboardResourceItem
                    title={x.Name}
                    subTitle={x.ModelName}
                    imagePath={x.Pictures.length ? x.Pictures[0] : ''}
                    objectFit={ObjectFitType.Contain}
                    onClick={() => handleRedirect(x.WhereToBuy.length ? x.WhereToBuy[0].Link : storeMainLink)}
                    fullWidth
                  />
                </Grid>
              ))}
          </Grid>
        )}
      </Box>
      <Button type="accent" center onClick={() => window.open(storeMainLink, '_blank')}>
        {tc('buttons.seeMore')}
      </Button>
    </Page>
  );
};

export default MeterDevices;
